import {
  AfterViewInit,
  Component,
  Injector,
  Input,
  ViewChild,
} from '@angular/core';
import { Item, Restaurant } from '../../models';
import { ItemService } from '../../services';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MessageService } from '@shared';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-item-grid',
  templateUrl: './item-grid.component.html',
  styleUrls: ['./item-grid.component.scss'],
})
export class ItemGridComponent implements AfterViewInit {
  @Input() restaurant: Restaurant | null = null;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  items: Item[] = [];
  dataSource = new MatTableDataSource<Item>(this.items);
  displayedColumns: string[] = [
    'name',
    'kitchenName',
    'plu',
    'price',
    'active',
    'isCombo',
    'availableSunday',
    'availableMonday',
    'availableTuesday',
    'availableWednesday',
    'availableThursday',
    'availableFriday',
    'availableSaturday',
  ];
  loading: boolean = false;
  elapsedSeconds: number = 0;

  constructor(
    private itemService: ItemService,
    private notificationService: MessageService,
    injector: Injector,
  ) {}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(): void {
    this.loadItems();
  }

  loadItems(): void {
    this.loading = true;
    this.items = [];
    this.dataSource = new MatTableDataSource<Item>(this.items);
    this.dataSource.paginator = this.paginator;

    if (this.restaurant) {
      const startTime = Date.now();
      this.itemService.getItems().subscribe(
        (items: Item[]) => {
          const endTime = Date.now();
          this.elapsedSeconds = (endTime - startTime) / 1000;

          this.items = items;
          this.dataSource = new MatTableDataSource<Item>(this.items);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.loading = false;
          this.showNotification(
            `Items loaded in ${this.elapsedSeconds.toFixed(2)} seconds.`,
          );
        },
        (error) => {
          this.loading = false;
          this.notificationService.error(
            'Failed to load items. Please try again later.',
          );
          console.error('Error loading items:', error);
        },
      );
    }
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  exportToExcel(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.items);
    const workbook: XLSX.WorkBook = {
      Sheets: { Items: worksheet },
      SheetNames: ['Items'],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });
    this.saveAsExcelFile(excelBuffer, 'items');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, `${fileName}_export_${new Date().getTime()}.xlsx`);
  }

  showNotification(message: string): void {
    this.notificationService.info(message);
  }
}

const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
